import { render, staticRenderFns } from "./ThreadsItem.vue?vue&type=template&id=55566cf5"
import script from "./ThreadsItem.vue?vue&type=script&lang=ts"
export * from "./ThreadsItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports